import { ReferenceInput, SelectInput } from "ra-ui-materialui";

import React from "react";

const ResultTypeInput = (props) => (
  <ReferenceInput {...props} reference="result-types" sort={{ field: "name", direction: "ASC" }} allowEmpty>
    <SelectInput optionText="name" allowEmpty emptyText="ra.none_inside_brackets" />
  </ReferenceInput>
);
export default ResultTypeInput;
